<script>
import Socials from './SaleSocials';

export default {
  name: 'SalePreviewHeader',
  components: { Socials },
  data() {
    return {
      now: null,
    };
  },
  props: {
    name: {
      type: String,
      default: '-',
    },
    product: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getIconSrc() {
      // eslint-disable-next-line global-require,import/no-dynamic-require
      return require(`@/assets/img/${this.$chain.getName()}/launchpad/${this.product.icon}.jpg`);
    },
  },
};
</script>

<template>
  <div class="d-flex justify-space-between mb-5">
    <div class="d-flex align-center flex-grow-1">
      <div class="upcoming-card__icon">
        <img :src="getIconSrc()" />
      </div>
      <div class="ml-5 d-block d-sm-flex justify-space-between flex-grow-1">
        <div>
          <div class="d-flex align-center mb-3 justify-end justify-sm-start">
            <span class="upcoming-card__title font-weight-bold" v-html="name">
            </span>
          </div>
          <div class="footer__social justify-sm-start justify-end">
            <Socials
              v-for="(social, index) in product.socialLinks"
              :key="index"
              :social="social"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.upcoming-card {
  &__icon {
    body.binance & {
      color: $b-secondatry-font-color;
      background: $b-main-bg;
      box-shadow: $b-pools-select-shadow;
    }
  }

  &__step {
    body.binance & {
      color: $b-secondatry-font-color;
      background: $b-main-bg;
      box-shadow: $b-pools-select-shadow;
    }
  }

  &__countdown {
    body.binance & {
      color: $b-binance-color;
    }
  }
}
</style>
